import PropTypes from 'prop-types';
import React from 'react';

import styles from './firmware-update-dialog.css';

const formatVersion = version => (version || '').replace(/\.0$/, '');

const FirmwareUpdateDialog = ({
    currentVersion,
    deviceName,
    latestVersion,
    mandatory,
    onClose,
    onSkip,
    onUpdate,
}) => (
    <div className={styles.overlay}>
        <div className={styles.modal}>
            <button
                aria-label="Close"
                className={styles.closeButton}
                onClick={onClose}
            />
            <div className={styles.header}>
                <h2>{mandatory ? 'Firmware Update Required' : 'Firmware Update Available'}</h2>
            </div>

            <div className={styles.content}>
                <div className={styles.deviceInfo}>
                    <p className={styles.deviceName}>{deviceName}</p>
                    <div className={styles.versionComparison}>
                        <div className={styles.versionBox}>
                            <span className={styles.versionLabel}>{'Current Version'}</span>
                            <span className={styles.versionNumber}>{currentVersion}</span>
                        </div>
                        <div className={styles.arrow}>{'→'}</div>
                        <div className={styles.versionBox}>
                            <span className={styles.versionLabel}>{'Latest Version'}</span>
                            <span className={`${styles.versionNumber} ${styles.latest}`}>{formatVersion(latestVersion)}</span>
                        </div>
                    </div>
                </div>

                <div className={styles.message}>
                    <p>
                        {mandatory ?
                            'This firmware version is no longer supported. Please update to continue.' :
                            'A new firmware version is available for your device.'}
                    </p>
                    <p className={styles.warning}>
                        {'⚠️ Updating firmware will require you to disconnect and reconnect your device.'}
                    </p>
                </div>

                <div className={styles.actions}>
                    <button
                        className={styles.updateButton}
                        onClick={onUpdate}
                    >
                        {'Update Firmware'}
                    </button>
                    {!mandatory && (
                        <button
                            className={styles.skipButton}
                            onClick={onSkip}
                        >
                            {'Skip for now'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    </div>
);

FirmwareUpdateDialog.propTypes = {
    currentVersion: PropTypes.string.isRequired,
    deviceName: PropTypes.string,
    latestVersion: PropTypes.string.isRequired,
    mandatory: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSkip: PropTypes.func,
    onUpdate: PropTypes.func.isRequired,
};

export default FirmwareUpdateDialog;
